import { Gauge, Search, ClipboardCheck, MessageSquareQuote } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const features = [
  {
    icon: Gauge,
    title: "AI Visibility Score",
    description: "A 0-100 score showing how AI platforms see and recommend your brand. Based on real-time AI queries.",
  },
  {
    icon: Search,
    title: "Google Ranking Check",
    description: "Your exact position for the target keyword. Domain verification and spelling detection included.",
  },
  {
    icon: ClipboardCheck,
    title: "Technical AI Audit",
    description: "4 checks that show if AI crawlers can access your site: robots.txt · sitemap.xml · llms.txt · Schema markup. With guidance on how to fix issues.",
  },
  {
    icon: MessageSquareQuote,
    title: "Live AI Evidence",
    description: "See the exact query we sent to ChatGPT and a preview of how it responded.",
  },
];

const WhatYouGet = () => {
  const ref = useScrollReveal();
  const gridRef = useScrollReveal<HTMLDivElement>({ stagger: true });

  return (
    <section ref={ref} className="py-10 md:py-16 px-4 bg-secondary/30">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-10">
          What the automated scan includes
        </h2>

        <div ref={gridRef} className="grid md:grid-cols-2 gap-6 mb-8">
          {features.map((f) => (
            <div
              key={f.title}
              className="border-2 border-border bg-card p-6 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md"
            >
              <div className="p-2 border-2 border-border bg-background inline-block mb-4 shadow-2xs">
                <f.icon className="w-5 h-5 text-foreground" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">{f.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>

        <p className="text-sm text-muted-foreground text-center">
          Scores are based on peer-reviewed academic research.
        </p>
      </div>
    </section>
  );
};

export default WhatYouGet;
